import StackedBarChart from "./StackedBarChart";
import BarChart from "./BarChart";
import AreaChart from "./AreaChart";
import { Chart } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import MultiLineChart from "./MultiLineChart";

export default function GraphFactory({ graphData, desiredGraphOptions }) {

    Chart.register(annotationPlugin);

    const renderGraph = () => {
        if(desiredGraphOptions.plot === "Cumulative savings") {
            return (
                <AreaChart
                    graphData={graphData}
                    desiredGraphOptions={desiredGraphOptions}
                />
            );
        }
        if(desiredGraphOptions.filterCategories.type === "SUM" && (desiredGraphOptions.graphType === "EXPENSES" || desiredGraphOptions.graphType === "INCOMES")) {
            return (
                <BarChart
                    graphData={graphData}
                    desiredGraphOptions={desiredGraphOptions}
                />
            );
        } else {
            return (
                <StackedBarChart
                    graphData={graphData}
                    desiredGraphOptions={desiredGraphOptions}
                />
            );
        }
        // En casos raros
        // return (
        //     <MultiLineChart
        //         graphData={graphData}
        //         desiredGraphOptions={desiredGraphOptions}
        //     />
        // );
    }

    return renderGraph()
}